import DeleteOutline from '@mui/icons-material/DeleteOutline';
import { useState } from 'react';

import { useUpdatePiecesMutation } from '@api/piece';
import { PieceAction } from '@apiContract';
import { buildUpdatePiecesRequest } from '@components/MailpieceActions/components/actions/helper';
import { DialogConfirmation } from '@uiKit/DialogConfirmation';

import { showApiErrorToast } from '@utils/apiErrorToast';

import { CaptureId } from '../../types';
import DefaultIconWithLoader from './components/DefaultIconWithLoader';

type Props = {
  tooltip?: string;
  disabled?: boolean;
  onClick: (id: number) => void;
  id?: CaptureId | null;
};

const DeleteIcon = ({ tooltip, disabled, onClick, id }: Props) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [updatePieces, { isLoading: isDeleteLoading }] = useUpdatePiecesMutation();
  return (
    <>
      <DefaultIconWithLoader
        Icon={DeleteOutline}
        tooltip={tooltip}
        disabled={disabled}
        onClick={() => setIsDialogOpen(true)}
      />
      <DialogConfirmation
        maxWidth="xs"
        open={isDialogOpen}
        loading={isDeleteLoading}
        handleClose={() => setIsDialogOpen(false)}
        type="error"
        title="Delete item"
        content={'Are you sure you would like to permanently delete this item?'}
        acceptButtonTitle="Delete"
        acceptButtonHandleClick={async () => {
          if (!id) return;
          const requestData = buildUpdatePiecesRequest({
            mailpieces: [{ id: +id }],
            action: PieceAction.Delete,
          });
          try {
            await updatePieces(requestData).unwrap();
            onClick(+id);
            setIsDialogOpen(false);
          } catch (error) {
            showApiErrorToast(error);
          }
        }}
        cancelButtonTitle="Cancel"
        cancelButtonHandleClick={() => setIsDialogOpen(false)}
      />
    </>
  );
};

export default DeleteIcon;
